export default "__VITE_ASSET__CeOSzd8Z__"